<template>
  <div class="menu-table">
    <el-table
      v-loading="loading"
      stripe
      :tree-props="{ children: 'childList' }"
      row-key="id"
      :load="load"
      lazy
      size="small"
      max-height="540"
      :data="tableData"
    >
      <template v-for="(item, index) in tableJson">
        <el-table-column
          :prop="item.filed"
          :key="index"
          :label="item.label"
          :min-width="item.width ? item.width : '120'"
        >
          <template slot-scope="scope">
            <span :title="scope.row[item.filed]" v-if="!item.type || item.type === 'span'">
              {{ scope.row[item.filed] | format }}
            </span>
            <hl-tag
              v-else-if="item.type === 'tag'"
              :style="{ ...item.colorList[scope.row[item.filed]] }"
            >
              {{ item.formatFn(scope.row[item.filed], scope.row) }}
            </hl-tag>
          </template>
        </el-table-column>
      </template>
      <el-table-column
        v-if="operation.length && Number(width)"
        fixed="right"
        label="操作"
        :width="width"
      >
        <template slot-scope="scope">
          <template v-for="(oper, index) in operation">
            <el-button
              v-if="(oper.hide && !oper.hide()) || !oper.hide"
              class="table-btn"
              size="small"
              :disabled="oper.disabled"
              @click.native.prevent="handleOperation(oper.type, scope.row)"
              type="text"
              :key="index"
            >
              {{ oper.name }}
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import Tag from '@manage/components/CommonTable/Tag'
export default {
  props: {
    tableJson: {
      type: Array,
      default: () => []
    },
    operation: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    width: {
      type: String,
      default: '200'
    }
  },
  data() {
    return {}
  },
  components: {
    'hl-tag': Tag
  },
  computed: {
    loading() {
      return this.$store.state.tableLoading
    },
    tableData() {
      let data = this.setHasChildren(this.data)
      return data
    }
  },
  filters: {
    format(val) {
      if (!val && val !== 0) {
        return '--'
      }
      return val
    }
  },
  methods: {
    setHasChildren(data) {
      return data.map((el) => {
        return { ...el, hasChildren: true }
      })
    },
    load(row, treeNode, resolve) {
      let params = {
        pageNo: 1,
        pageSize: 9999,
        pid: row.id
      }
      this.$ajax.get(this.$api.system.menu_list, params).then((res) => {
        if (res.data.list && res.data.list.length) {
          resolve(this.setHasChildren(res.data.list))
        } else {
          resolve([])
        }
      })
    },
    handleOperation(type, row) {
      this.$emit('operation', { type, row })
    }
  }
}
</script>
<style lang="less" scoped>
.menu-table {
  .table-btn {
    padding-top: 0;
    padding-bottom: 0;
  }
  .table-pagination {
    text-align: right;
    margin: 15px;
    margin-bottom: 0px;
  }
}
</style>
